/// <reference path="../Controller.ts" />
/// <reference path="./FormItemController.ts" />
/// <reference path="../../HTML/Form/Item/Select.ts" />
/// <reference path="../../HTML/Editor/Selector.ts" />
namespace HA.Core.Controller.Form {
    import Selector = HA.Core.HTML.Editor.Selector;
    import Select = HA.Core.HTML.Form.Select;

    //@Todo
    export class CheckboxController extends FormItemController {

        /**
         *
         * @returns {any|string}
         */
        public getValue() {
            return this.getTag().getSelected();
        }

        /**
         *
         * @returns {boolean}
         */
        public isInputItem() {
            return true;
        }

        /**
         *
         * @returns {any}
         */
        protected createItem() {
            const data = toMap({tag: this.getTag()});
            const me = this;
            data.set("click", () => {
                const tag = new Selector(toMap({
                    dlist: me.getChoices(),
                    pfunc: {
                        itemClick: (d: any) => {
                            me.itemClicked(d, tag);
                        },
                    },
                    title: me.getTitle(),
                    waccept: () => {
                        me.wAccept(tag.getSelections());
                    },
                    wcancel: () => {
                        me.getFormController().closeSelection(me.getAppId());
                    },
                }));
                const app2 = HA.Core.Service.App.createFSApp(tag);
                me.setAppId(app2.getId());
                me.getFormController().showSelection(app2);
            });
            return new Select(data);
        }

        /**
         * @param items
         */
        protected replaceItems(items: any[]) {
            this.getTag().replaceItems(items);
        }

        /**
         *
         * @returns {Map}
         */
        protected getChoices() {
            return this.getTag().getChoices();
        }

        protected initItem() {
            super.initItem();
            this.addToData("max", this.getTag().getMax());
        }

        private itemClicked(data: any, tag: Selector): void {
            const max = this.get("max");
            if (!max || max > tag.getSelections().length) {
                return;
            }
            if (max === 1) {
                tag.deselectAll();
                tag.select(data);
            }
            this.wAccept(tag.getSelections());
        }

        private wAccept(selections: any): void {
            this.getFormController().closeSelection(this.getAppId());
            this.replaceItems(selections);
            const me = this;
            timeout(()=>{me.getTag().scrollIntoView();}, 200);

        }
    }
}
